import profiles from './profiles';

export default function* () {
    yield* [
        ...profiles
    ];
}